module.exports = {
	status: 'ready',
	title: 'Nav Bar',
	context: {
		title: 'Mer på Aktuellt & Press',
		items: [
			'Informationsmateriel',
			'Bilder & Filmer',
			'Grafisk profil & Logotyp'
		]
	}
};